import React, { useState } from "react";
import { Dialog, FormControl, DialogTitle, Select, DialogContent, DialogActions, Button, withStyles, MenuItem } from '@material-ui/core';
import * as actions from './store/colliActions';
import { connect } from 'react-redux';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
            borderRadius: '1px'
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: '1px'
        }
    },
    formControl: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        width: '90%'
    }
});


const ActiveWarehouse = props => {
    const { classes, warehouses, handleCloseActiveWarehouseForm, setActiveWarehouse, activeCustomerID, translations, setWarehouseActive, activeWarehouseID } = props;
    const [selectedWarehouseActiveID, setSelectedWarehouseActiveID] = useState(activeWarehouseID ? activeWarehouseID : warehouses.data && warehouses.data.length > 0 ? warehouses.data[0].value : '');

    const submitHandler = async () => {
        await setActiveWarehouse({ ActiveWarehouseID: selectedWarehouseActiveID, ActiveCustomerID: activeCustomerID });
        let name = warehouses.data.filter(warehouse => warehouse.value === selectedWarehouseActiveID)
        setWarehouseActive({ ...warehouses, open: false, name: name })
    };

    return (
        <Dialog open={warehouses.open}
            onClose={handleCloseActiveWarehouseForm}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}>
            <DialogTitle id="form-dialog-title">{translations["please_choose_active_warehouse"] || "Please choose active warehouse"}</DialogTitle>
            <DialogContent>
                <FormControl className={classes.formControl} margin={"dense"}>
                    <Select
                        name="active_warehouse"
                        label={translations["active_warehouse"] || "Active Warehouse"}
                        margin={"dense"}
                        value={selectedWarehouseActiveID}
                        fullWidth={true}
                        onChange={(event) => setSelectedWarehouseActiveID(event.target.value)}
                    >
                        {(warehouses && warehouses.data ? warehouses.data : []).map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.displayValue}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseActiveWarehouseForm} variant="contained" className={classes.buttonSafe}>
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button onClick={submitHandler} variant="contained" className={classes.buttonDanger}>
                    {translations['submit'] || 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setActiveWarehouse: (params) => dispatch(actions.setActiveWarehouse(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ActiveWarehouse));

